export default __webpack_public_path__ + "static/media/elevate-wht-4.9e505545.png";